import { ColorSchemeToggle, useSessionCheck } from '@gofranz/common-components';
import {
  ActionIcon,
  AppShell,
  Box,
  Divider,
  Group,
  Menu,
} from '@mantine/core';
import { useLocation } from 'react-router-dom';
import { useRustyState } from '../../state';
import { AccountNavigation } from './AccountNavigation';
import { IconUser } from '@tabler/icons-react';
import { LanguageSelector } from '../LanguageSelector/LanguageSelector';

export interface AccountLayoutProps {
  children: React.ReactNode;
  isLoggedIn: boolean;
}

export function AccountLayout({ children, isLoggedIn }: AccountLayoutProps) {
  const location = useLocation();


  // Detect if we're on a page that needs special scroll handling (no container scrolling)
  const hasCustomScrolling = location.pathname.includes('/chat');

  // Use the shared session check hook
  useSessionCheck({
    auth: useRustyState.getState().api.auth,
    isLoggedIn,
    logout: useRustyState.getState().logout,
    checkInterval: 10000, // 10 seconds
  });

  const AccountHeader = () => (
    <Box
      p="md"
      style={{
        borderBottom: '1px solid var(--mantine-color-default-border)',
        backgroundColor: 'var(--mantine-color-default)',
        zIndex: 10,
      }}
    >
      <Group justify="space-between" align="center">
        <div />
        <Group align="center" gap="md">
          {isLoggedIn && (
            <Menu shadow="md" width={250}>
              <Menu.Target>
                <ActionIcon
                  variant="subtle"
                  color="gray"
                  aria-label="Account"
                >
                  <IconUser size={18} />
                </ActionIcon>
              </Menu.Target>

              <Menu.Dropdown>
                <Box p="xs">
                  <Group justify="space-between" mb="sm">
                    <LanguageSelector />
                    <ColorSchemeToggle />
                  </Group>
                  <Divider mb="xs" />
                  <AccountNavigation />
                </Box>
              </Menu.Dropdown>
            </Menu>
          )}
        </Group>
      </Group>
    </Box>
  );

  return (
    <Box h="100vh" style={{ overflow: hasCustomScrolling ? 'hidden' : 'auto' }}>
      <AppShell
        // navbar={{
        //   width: 300,
        //   breakpoint: 'sm',
        //   collapsed: { mobile: !mobileOpened, desktop: !desktopOpened },
        // }}
        padding={hasCustomScrolling ? 0 : "md"}
      >
        {!hasCustomScrolling && <AccountHeader />}
        <AppShell.Main style={hasCustomScrolling ? { height: '100%', overflow: 'hidden' } : {}}>{children}</AppShell.Main>
      </AppShell>
    </Box>
  );
}
